<template>
  <div>
    <b-row>
      <b-col>
        <header-view
          :title="title"
          :icon="'ti-user'">
        </header-view>
      </b-col>
    </b-row>
    <business-card
            class="rounded-0 h-100"
            :name="policyHolder.firstName + ' ' + policyHolder.lastName"
            :relation="$t('enums.relationTypes.' + policyHolder.relationshipType)"
            :email="policyHolder.email"
            :imageSrc="policyHolder.avatarUuid"
            :showIcon="!!policyHolder.dateOfDeath"
            :dateOfDeath="policyHolder.dateOfDeath"
            variant="noHover">
            <div slot="bcFooter">
              <hr>
              <div class="d-flex flex-row">
                <b-badge class="p-2 mr-2">
                  {{ policyHolder.numberOfAssignedContracts }}
                </b-badge>
                <div>
                  {{ getNumberOfAssignedContractsText(policyHolder) }}
                </div>
              </div>
            </div>
          </business-card>
    <b-row class="mt-4">
      <b-col>
        <b-card class="rounded-0" v-if="!this.$store.getters.policyHolderContracts">
          <p>{{ $t('message.policyHolderDetails.infoText', { policyHolderName: policyHolderName }) }}</p>
        </b-card>
        <b-card class="rounded-0" v-if="this.$store.getters.policyHolderContracts">
          <p>{{ $t('message.policyHolderDetails.infoText2', { policyHolderName: policyHolderName }) }}</p>
        </b-card>

        <policy-holder-contracts v-if="this.$store.getters.policyHolderContracts"></policy-holder-contracts>

        <b-row class="mt-4" v-if="!codOrCoiApproved">
          <b-col>
            <h6>{{ $t('message.policyHolderDetails.reportDeath', { policyHolderName: policyHolderName }) }}</h6>
          </b-col>
        </b-row>
        <b-row
          :class="[codOrCoiApproved ? 'mt-4' : 'mt-2']">
          <b-col cols="6">
            <b-card class="rounded-0">
              {{ $t('message.policyHolderDetails.certificateOfDeath') }}
              <spinner size="80" :line-size="12" line-fg-color="grey" line-bg-color="lightgrey" :speed="1.5"
                       v-if="loadingCertificateOfDeath">
              </spinner>
              <b-form-file
                v-if="!certificateOfDeath && !loadingCertificateOfDeath"
                class="rounded-0 mt-4"
                accept="application/pdf, image/*"
                ref="certificateOfDeath"
                v-model="certificateOfDeath"
                v-on:change="uploadCertificateOfDeath">
              </b-form-file>

              <b-row>
                <b-col>
                  <b-btn
                    v-if="certificateOfDeath && !loadingCertificateOfDeath"
                    variant="transparent"
                    class="p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate"
                    @click="printCertificateOfDeath">
                    <b-alert
                      show
                      variant="dark"
                      class="rounded-0 certificate pb-0 mb-0">
                      <p>
                        <span class="ti-printer mr-2"></span>
                        {{ $t('message.policyHolderDetails.certificateOfDeathMessage') }}
                      </p>
                      <p
                        v-if="!codApproved"
                        class="text-left">
                        {{ $t('message.policyHolderDetails.certificateOfDeathEnable', { policyHolderName:
                        policyHolderName
                        }) }}
                      </p>
                    </b-alert>
                  </b-btn>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="text-right">
                  <b-btn
                    v-if="certificateOfDeath && !loadingCertificateOfDeath && isCodOwner && !codApproved"
                    variant="danger"
                    class="mt-3"
                    v-b-modal.delete_cod>
                    {{ $t('message.policyHolderDetails.deleteDocument') }}
                  </b-btn>
                </b-col>
              </b-row>

            </b-card>
          </b-col>
          <b-col cols="6">
            <b-card class="rounded-0">
              {{ $t('message.policyHolderDetails.certificateOfInheritance') }}
              <spinner size="80" :line-size="12" line-fg-color="grey" line-bg-color="lightgrey" :speed="1.5"
                       v-if="loadingCertificateOfInheritance">
              </spinner>
              <b-form-file
                v-if="!certificateOfInheritance && !loadingCertificateOfInheritance"
                class="rounded-0 mt-4"
                accept="application/pdf"
                ref="certificateOfInheritance"
                v-model="certificateOfInheritance"
                v-on:change="uploadCertificateOfInheritance">
              </b-form-file>

              <b-row>
                <b-col>
                  <b-btn
                    v-if="certificateOfInheritance && !loadingCertificateOfInheritance"
                    variant="transparent"
                    class="p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate"
                    @click="printCertificateOfInheritance">
                    <b-alert
                      show
                      variant="dark"
                      class="rounded-0 certificate pb-0 mb-0">
                      <p>
                        <span class="ti-printer mr-2"></span>
                        {{ $t('message.policyHolderDetails.certificateOfInheritanceMessage') }}
                      </p>
                      <p
                        v-if="!coiApproved"
                        class="text-left">
                        {{ $t('message.policyHolderDetails.certificateOfInheritanceEnable',
                        { policyHolderName: policyHolderName }) }}
                      </p>
                    </b-alert>
                  </b-btn>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="text-right">
                  <b-btn
                    v-if="certificateOfInheritance  && !loadingCertificateOfInheritance && !coiApproved"
                    variant="danger"
                    class="mt-3"
                    v-b-modal.delete_coi>
                    {{ $t('message.policyHolderDetails.deleteDocument') }}
                  </b-btn>
                </b-col>
              </b-row>

            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-modal id="delete_cod"
             cancel-variant="primary"
             ok-variant="danger"
             :title="$t('message.policyHolderDetails.modal.title')"
             :ok-title="$t('message.policyHolderDetails.modal.ok')"
             :cancel-title="$t('message.policyHolderDetails.modal.cancel')"
             @ok="deleteCertificateOfDeath">
      <p class="mt-4">{{ $t('message.policyHolderDetails.modal.message') }}</p>
    </b-modal>
    <b-modal id="delete_coi"
             cancel-variant="primary"
             ok-variant="danger"
             :title="$t('message.policyHolderDetails.modal.title')"
             :ok-title="$t('message.policyHolderDetails.modal.ok')"
             :cancel-title="$t('message.policyHolderDetails.modal.cancel')"
             @ok="deleteCertificateOfInheritance">
      <p class="mt-4">{{ $t('message.policyHolderDetails.modal.message') }}</p>
    </b-modal>
  </div>
</template>

<script>
  import b64toBlob from 'b64-to-blob'
  import Spinner from 'vue-simple-spinner'
  import HeaderView from '@/components/common/HeaderView'
  import PolicyHolderContracts from '@/components/policyholder/PolicyHolderContracts'
  import BusinessCard from '@/components/common/BusinessCard'
  import utils from '@/utils'

  export default {
    name: 'PolicyHolderDetails',
    beforeRouteUpdate (to, from, next) {
      this.$store.commit('setCertificateOfDeath', null)
      this.$store.commit('setCertificateOfInheritance', null)
      this.$store.dispatch('fetchPolicyHolderById', to.params.id)
        .then(() => {
          this.$store.dispatch('fetchContractsByPolicyHolderId', to.params.id)
            .then(() => {
              this.loadingCertificateOfDeath = true
              this.loadingCertificateOfInheritance = true
              return this.$store.dispatch('fetchDocuments', to.params.id).finally(() => {
                this.loadingCertificateOfDeath = false
                this.loadingCertificateOfInheritance = false
              })
            })
        })
        .then(() => {
          next()
        })
        .catch(() => {
          this.showErrorMsg({
            message: this.$t('error.policyHolderDetails.policyHolderById')
          })
          this.$router.replace('/policyHolders')
        })
    },
    components: {
      HeaderView,
      PolicyHolderContracts,
      Spinner,
      BusinessCard
    },
    computed: {
      certificateOfDeath () {
        return this.$store.getters.certificateOfDeath
      },
      codOrCoiApproved () {
        return this.$store.getters.policyHolderContracts
      },
      codApproved () {
        return this.policyHolder.certificateOfDeathApproved
      },
      coiApproved () {
        return this.policyHolder.certificateOfInheritanceApproved
      },
      certificateOfInheritance () {
        return this.$store.getters.certificateOfInheritance
      },
      isCodOwner () {
        return this.$store.getters.certificateOfDeath.uploaderId === this.$store.getters.currentUser.id
      },
      policyHolder () {
        return this.$store.getters.policyHolder
      },
      policyHolderName () {
        return this.policyHolder.firstName + ' ' + this.policyHolder.lastName
      },
      title () {
        return this.$t('message.policyHolderDetails.title', {
          firstName: this.policyHolder.firstName,
          lastName: this.policyHolder.lastName
        })
      }
    },
    created () {
      const id = parseInt(this.$route.params.id)
      if (id) {
        const filteredPolicyHolders = this.$store.getters.policyHolders.filter(contactPerson => contactPerson.id === id)
        if (filteredPolicyHolders.length === 0) {
          this.$store.dispatch('fetchPolicyHolderById', id)
            .catch(() => {
              this.showErrorMsg({
                message: this.$t('error.policyHolderDetails.policyHolderById')
              })
              this.$router.replace('/policyHolders')
            })
        } else {
          this.$store.commit('setPolicyHolder', filteredPolicyHolders[0])
        }
        if (!this.certificateOfDeath || !this.certificateOfInheritance) {
          this.loadingCertificateOfDeath = true
          this.loadingCertificateOfInheritance = true
          this.$store.dispatch('fetchCertificateOfDeath', id).finally(() => {
            this.loadingCertificateOfDeath = false
          })
          this.$store.dispatch('fetchCertificateOfInheritance', id).finally(() => {
            this.loadingCertificateOfInheritance = false
          })
        }
        this.$store.dispatch('fetchContractsByPolicyHolderId', id)
      } else {
        this.router.replace('/policyHolders')
      }
    },
    data () {
      return {
        loadingCertificateOfDeath: false,
        loadingCertificateOfInheritance: false
      }
    },
    methods: {
      getNumberOfAssignedContractsText (policyHolder) {
        if (policyHolder.numberOfAssignedContracts === 1) {
          return this.$t('message.dashboardContentContactPerson.numberOfAssignedContract')
        } else {
          return this.$t('message.dashboardContentContactPerson.numberOfAssignedContracts')
        }
      },
      deleteCertificateOfDeath () {
        this.$store.dispatch('deleteCertificateOfDeath', this.policyHolder.id)
          .catch(() => {
            this.showErrorMsg({
              message: this.$t('error.policyHolderDetails.deleteCertificateOfDeath')
            })
          })
      },
      printCertificateOfDeath () {
        utils.download(this.certificateOfDeath)
      },
      deleteCertificateOfInheritance () {
        this.$store.dispatch('deleteCertificateOfInheritance', this.policyHolder.id)
          .catch(() => {
            this.showErrorMsg({
              message: this.$t('error.policyHolderDetails.deleteCertificateOfInheritance')
            })
          })
      },
      printCertificateOfInheritance () {
        const certificateOfInheritance = this.certificateOfInheritance
        if (certificateOfInheritance) {
          const contentType = 'application/pdf'
          const blob = b64toBlob(certificateOfInheritance.file, contentType)
          utils.downloadBlob(blob, this.$t('message.policyHolderDetails.certificateOfInheritance'))
        }
      },
      uploadCertificateOfDeath (fileEvent) {
        let file = null
        try {
          if (fileEvent.target.files.length > 0) {
            file = fileEvent.target.files[0]
          }
        } catch (ex) {
          file = null
        }
        if (file) {
          this.loadingCertificateOfDeath = true
          this.$store.dispatch('uploadCertificateOfDeath', {
            policyHolderId: this.policyHolder.id,
            certificateOfDeath: file
          }).then(() => {
            this.showSuccessMsg({
              message: this.$t('message.policyHolderDetails.uploadCertificateOfDeath')
            })
          }).catch(() => {
            this.showErrorMsg({
              message: this.$t('error.policyHolderDetails.uploadCertificateOfDeath')
            })
          }).finally(() => {
            this.loadingCertificateOfDeath = false
          })
        }
      },
      uploadCertificateOfInheritance (fileEvent) {
        let file = null
        try {
          if (fileEvent.target.files.length > 0) {
            file = fileEvent.target.files[0]
          }
        } catch (ex) {
          file = null
        }
        if (file) {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => {
            const base64Value = reader.result.split(',')[1]
            this.$store.dispatch('uploadCertificateOfInheritance', {
              policyHolderId: this.policyHolder.id,
              documents: {
                certificateOfInheritance: base64Value
              }
            }).then(() => {
              this.showSuccessMsg({
                message: this.$t('message.policyHolderDetails.uploadCertificateOfInheritance')
              })
            }).catch(() => {
              this.showErrorMsg({
                message: this.$t('error.policyHolderDetails.uploadCertificateOfInheritance')
              })
            }).finally(() => {
              this.loadingCertificateOfInheritance = false
            })
          }
          reader.onerror = () => {
            this.showErrorMsg({
              message: this.$t('error.policyHolderDetails.fileReaderError')
            })
          }
        }
      }
    },
    notifications: {
      showErrorMsg: {
        type: 'error'
      },
      showSuccessMsg: {
        type: 'success'
      }
    }
  }
</script>

<style scoped>
  .btn-certificate {
    white-space: normal !important;
  }

  .certificate {
    min-height: 50px;
    min-width: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/policyholder/PolicyHolderDetails.vue